// Module
var code = "<div class=\"flex layout-column\">\n    <mn-system-parameter class=\"flex\" key=\"oximetry_config\" attr=\"protocols\">\n        <mn-oximetry-config-table mn-model=\"vm.model\" mn-auto-save=\"vm.handleAutoSave\" attr=\"protocols\">\n        </mn-oximetry-config-table>\n    </mn-system-parameter>\n</div>";
// Exports
module.exports = code;